import React from 'react';

const Hero = () => {
  return (
    <section className="gradient-bg pt-8 sm:pt-12 lg:pt-20 pb-20 overflow-hidden">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 items-center">
            {/* Contenido izquierda */}
            <div className="text-center lg:text-left px-6 lg:px-0">
              {/* Título Principal */}
              <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight animate-slide-up">
                Crea actividades, tareas y exámenes 
                <span className="text-primary-600 block">para tu clase en segundos</span>
                <span className="text-secondary-600"> con IA</span>
              </h1>
              
              {/* Subtítulo */}
              <p className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-8 sm:mb-12 leading-relaxed animate-slide-up px-2 lg:px-0">
                Material educativo listo para usar en tu aula.
              </p>
              
              {/* CTA Principal */}
              <div className="flex flex-col items-center lg:items-start mb-6 sm:mb-8 animate-slide-up px-6 lg:px-0">
                <a
                  href="#cta"
                  onClick={(e) => {
                    e.preventDefault();
                    const cta = document.getElementById('cta');
                    if (cta) {
                      const headerHeight = 72;
                      const top = cta.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                      window.scrollTo({ top, behavior: 'smooth' });
                    }
                  }}
                  className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 mb-3 inline-block text-center w-full sm:w-auto"
                >
                  🚀 Quiero acceso anticipado
                </a>
                <p className="text-gray-500 text-xs sm:text-sm italic mb-2 px-2">
                  Cupos limitados para acceso anticipado
                </p>
                <p className="text-gray-600 text-xs sm:text-sm px-2">
                  Buscamos docentes para probar <span className="text-primary-600 font-bold">Tareia</span> antes del lanzamiento
                </p>
              </div>
            </div>

            {/* Preview PDF derecha - MATERIAL DIDÁCTICO REAL */}
            <div className="animate-fade-in">
              <div className="relative">
                {/* Badge flotante principal */}
                <div className="absolute -top-4 -right-4 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-xl z-10 animate-pulse">
                  📋 Material listo
                </div>
                
                {/* Mockup PDF - MATERIAL DIDÁCTICO */}
                <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 border-2 border-gray-100 transform rotate-1 hover:rotate-0 transition-all duration-500 hover:shadow-3xl">
                  <div className="space-y-5">
                    {/* Encabezado del material */}
                    <div className="border-b-2 border-primary-200 pb-4 bg-gradient-to-r from-primary-50 to-secondary-50 rounded-xl p-4 -m-2">
                      <p className="text-xs text-gray-900 mb-1 font-bold">📄 MATERIAL DIDÁCTICO GENERADO</p>
                      <h3 className="text-xl md:text-2xl font-bold text-purple-600 mb-2">🔬 Mini Escape: El laboratorio perdido</h3>
                      <div className="flex gap-2 text-sm text-gray-700 flex-wrap">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium border">🎓 Secundaria</span>
                        <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full font-medium border">🔬 Ciencias</span>
                        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-medium border">⏱️ 25 min</span>
                      </div>
                    </div>
                    
                    {/* Instrucciones para el docente */}
                    <div className="bg-blue-50 rounded-xl p-4 border-2 border-blue-200">
                      <h4 className="font-bold text-blue-900 mb-2 text-sm flex items-center">
                        👨‍🏫 GUÍA PARA EL DOCENTE:
                      </h4>
                      <div className="text-blue-800 text-sm space-y-2">
                        <p><strong>Narrativa:</strong> "Están atrapados en el laboratorio después de un experimento fallido. Solo pueden escapar resolviendo retos científicos."</p>
                        <p><strong>Preparación:</strong> Recorte las 4 tarjetas de retos. Divida la clase en equipos de 3-4 alumnos.</p>
                        <p><strong>Dinámica:</strong> Entregue solo la primera tarjeta. Los equipos deben mostrar la respuesta correcta antes de recibir la siguiente.</p>
                      </div>
                    </div>
                    
                    {/* Material para alumnos - Tarjetas recortables */}
                    <div className="space-y-3">
                      <h4 className="font-bold text-gray-900 text-sm mb-3">✂️ TARJETAS DE RETOS (Imprima una hoja por equipo):</h4>
                      
                      <div className="grid grid-cols-2 gap-3">
                        <div className="border-2 border-dashed border-red-400 rounded-lg p-3 bg-gradient-to-r from-red-50 to-red-100 shadow-sm">
                          <div className="text-center mb-2">
                            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">RETO 1</span>
                          </div>
                          <div className="text-center mb-2">
                            <span className="text-red-800 font-semibold text-xs">🌡️ Error de temperatura</span>
                          </div>
                          <div className="bg-white rounded-lg p-2 border border-red-300 mb-2">
                            <p className="text-red-900 text-xs mb-1"><strong>Nota del científico:</strong></p>
                            <p className="text-red-900 text-xs bg-yellow-100 p-1 rounded italic">"El agua hierve a 50°C"</p>
                          </div>
                          <div className="bg-white rounded-lg p-2 border-2 border-dashed border-red-300">
                            <p className="text-red-600 text-xs">Temperatura correcta: ____°C</p>
                          </div>
                        </div>
                        
                        <div className="border-2 border-dashed border-orange-400 rounded-lg p-3 bg-gradient-to-r from-orange-50 to-orange-100 shadow-sm">
                          <div className="text-center mb-2">
                            <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-full">RETO 2</span>
                          </div>
                          <div className="text-center mb-2">
                            <span className="text-orange-800 font-semibold text-xs">⚗️ Fórmula perdida</span>
                          </div>
                          <div className="bg-white rounded-lg p-2 border border-orange-300 mb-2">
                            <p className="text-orange-900 text-xs mb-1"><strong>Para activar el sistema:</strong></p>
                            <p className="text-orange-900 text-xs">Escriban la fórmula química del agua</p>
                          </div>
                          <div className="bg-white rounded-lg p-2 border-2 border-dashed border-orange-300">
                            <p className="text-orange-600 text-xs">Fórmula: ________</p>
                          </div>
                        </div>
                        
                        <div className="border-2 border-dashed border-green-400 rounded-lg p-3 bg-gradient-to-r from-green-50 to-green-100 shadow-sm">
                          <div className="text-center mb-2">
                            <span className="bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">RETO 3</span>
                          </div>
                          <div className="text-center mb-2">
                            <span className="text-green-800 font-semibold text-xs">🔬 Cálculo científico</span>
                          </div>
                          <div className="bg-white rounded-lg p-2 border border-green-300 mb-2">
                            <p className="text-green-900 text-xs mb-1"><strong>Problema del laboratorio:</strong></p>
                            <p className="text-green-900 text-xs">Una sustancia tiene masa de 20g y volumen de 10ml. Calculen su densidad</p>
                          </div>
                          <div className="bg-white rounded-lg p-2 border-2 border-dashed border-green-300">
                            <p className="text-green-600 text-xs">Densidad: ____ g/ml</p>
                          </div>
                        </div>
                        
                        <div className="border-2 border-dashed border-blue-400 rounded-lg p-3 bg-gradient-to-r from-blue-50 to-blue-100 shadow-sm">
                          <div className="text-center mb-2">
                            <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full">RETO 4</span>
                          </div>
                          <div className="text-center mb-2">
                            <span className="text-blue-800 font-semibold text-xs">🧊 Estados de la materia</span>
                          </div>
                          <div className="bg-white rounded-lg p-2 border border-blue-300 mb-2">
                            <p className="text-blue-900 text-xs mb-1"><strong>Última prueba:</strong></p>
                            <p className="text-blue-900 text-xs">Nombren los 3 estados principales de la materia</p>
                          </div>
                          <div className="bg-white rounded-lg p-2 border-2 border-dashed border-blue-300">
                            <p className="text-blue-600 text-xs">Estados: _______, _______, _______</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Hoja de respuestas incluida */}
                    <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-4 border-2 border-green-200">
                      <h4 className="font-bold text-green-900 mb-2 text-sm">📝 HOJA DE RESPUESTAS</h4>
                      <div className="text-green-800 text-xs space-y-1">
                        <p><strong>Reto 1:</strong> 100°C (no 50°C)</p>
                        <p><strong>Reto 2:</strong> H₂O</p>
                        <p><strong>Reto 3:</strong> 2 g/ml</p>
                        <p><strong>Reto 4:</strong> sólido, líquido, gaseoso</p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Badge "Listo para imprimir" mejorado */}
                <div className="absolute -bottom-4 -left-4 bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-xl">
                  🖨️ Listo para imprimir
                </div>
              </div>
              
              {/* Aclaración del ejemplo */}
              <p className="text-xs text-gray-400 text-center mt-4 italic">
                Ejemplo de actividad generada con <span className="text-primary-600 font-medium">Tareia</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;